import { z } from 'zod';

export const CompleteServiceRegistrationResponseSchema = z.object({
  serviceId: z.uuid(),
});

export type CompleteServiceRegistrationResponse = z.infer<
  typeof CompleteServiceRegistrationResponseSchema
>;

export const DiscardServiceDraftResponseSchema = z.object({
  serviceId: z.uuid(),
});

export type DiscardServiceDraftResponse = z.infer<typeof DiscardServiceDraftResponseSchema>;
